import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {map, mergeMap} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {MissingFieldForm} from '../entities/MissingFieldForm';
import {FormGroup, FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {OverlayComponent} from '../overlay/overlay.component';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [CommonModule, FormsModule, OverlayComponent],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.css'
})
export class RedirectComponent implements OnInit {

  isLoading: boolean = true;

  token: string | null = null;
  url: string | null = null;

  constructor(
    private activatedRoute: ActivatedRoute,
    private httpClient: HttpClient
  ) {
  }

  ngOnInit() {

    this.activatedRoute
      .queryParamMap
      .pipe(map(queryParamMap => {

        this.token = queryParamMap.get('token');
        this.url = queryParamMap.get('url');

        return this.token;
      }))
      .pipe(mergeMap(token => this.httpClient.get<any>(environment.apiUrl + '/form?token=' + token, {observe: 'response'})))
      .pipe(map(response => response.body))
      .pipe(map(body => {

        return MissingFieldForm.fromJson(body);
      }))
      .pipe(mergeMap(missingFieldForm => {

        let urlField = missingFieldForm
          .missingFields
          .find(mf => mf.fieldId === "url")

        if(urlField !== undefined && this.url !== null) {

          urlField.fieldValue = this.url;
        }

        return this.httpClient
          .post<any>(environment.apiUrl + '/form?token=' + this.token, missingFieldForm?.json(), {
            headers: this.buildHttpHeaders(),
            observe: 'response'
          })

      }))
      .subscribe(response => {

        this.activatedRoute
          .queryParamMap
          .pipe(map(queryParamMap => queryParamMap.get('url')))
          .subscribe(url => {

            console.log(url);

            if(url !== null) {

              window.location.href = url;
            }
          });
      });
  }

  private buildHttpHeaders() {

    return new HttpHeaders()
      .append('Content-Type', 'application/json');
  }
}
